import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import RupeeSymbolBlack from '../../../../../assets/img/Rupee-Symbol-Black.png'
import { updateActions } from '../../../../../_actions/user.action';
import CheckBoxUi from '../../../../../components/commonClass/CheckBoxUi';
import { ImageUpload } from '../../../../../ImageUpload/ImageCommon';
import { formatDateMonthYear } from '../../../../../components/commonClass/CommonValidation';
import { fetchIp, getDateCombination } from '../../../../../components/commonClass/CommonFunctions';
import { ClearLocalStorage, GetLocalStorage } from '../../../../../components/commonClass/Session';
import { loaderActions } from '../../../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../../../services/ApiCallingUserServices';

const FlightCancellation = ({ flightBookingData, setFlightModel, flightData, passangerPriceBU, cancelletionMessage, setCancellationMessage }: any) => {
    const [segment, setSegment] = useState<any>([])

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const [dropdownData, setDropdownData] = useState<any>({});
    const [formError, setFormError] = useState<any>({})
    const [amount, setAmount] = useState<any>();
    const [modalchange, setModalChnage] = useState<boolean>(false)
    const [formValue, setFormValue] = useState<any>({
        CancellationTypeId: 0,
        CancellationImagePath: '',
        CancellationImageName: '',
        Sectors: [],
        TicketId: [],
        Remarks: '',
        paxTypeWithTicketId: [],
        IsAcknowledgement: false
    })
    const createOptionData = (data: any) => {
        return data.map((obj: any) => ({ label: obj?.ReasonName, value: obj?.ReasonId }));
    }

    const RedirectToFllightListScreen = () => {
        const params = new URLSearchParams(searchParams);
        params.delete("tId");
        params.delete("rIndex");

        return '/flights/search?' + params.toString();
    }

    const partialCancelSegment = useMemo(() => {
        const partialCancelDetails = flightData?.response?.flightItinerary?.passenger
            ?.flatMap(({ paxType, partialCancelDetails = [] }: any) => [
                ...partialCancelDetails?.map((item: any) => ({ ...item, paxType })),
            ]) ?? [];
        return partialCancelDetails?.length > 0 ? partialCancelDetails : null;
    }, [flightData])


    const tripIndicatortraveller = useMemo(() =>
        partialCancelSegment?.filter((el: any) => formValue?.Sectors?.some((ele: any) => ele.tripIndicator === el.tripIndicator)),
        [partialCancelSegment, formValue?.Sectors])

    const travelListTicketIds = useMemo(() => flightBookingData?.flightDetails?.response?.flightItinerary?.passenger?.map((passenger: any) => (passenger?.ticket?.ticketId)),
        [flightBookingData?.flightDetails?.response?.flightItinerary?.passenger])

    const sectorWiseTicketIds: any = useMemo(() => {
        return formValue?.Sectors?.map((sec: any) => {
            sec.passengerTickets = flightData?.response?.flightItinerary?.passenger?.filter((passenger: any) => {
                const cancelledTickets = tripIndicatortraveller?.filter((el: any) => el.tripIndicator === sec?.tripIndicator)?.map((obj: any) => obj?.ticketId);
                return !cancelledTickets?.includes(passenger?.ticket?.ticketId)
            })?.map((obj: any) => obj?.ticket?.ticketId);
            return sec;
        })
    }, [flightData?.response?.flightItinerary?.passenger, tripIndicatortraveller, formValue?.Sectors])




    const TicketIds = useMemo(() => {
        const uniqueTickets = Array.from(
            new Map(
                (sectorWiseTicketIds ?? [])
                    .flatMap((item: any) => item.passengerTickets ?? [])
                    .map((ticket: any) => [ticket, ticket]) // key = value
            ).values()
        );

        return formValue?.Sectors?.length <= 1 ?
            sectorWiseTicketIds?.find((prev: any) =>
                prev?.tripIndicator === formValue?.Sectors?.[0]?.tripIndicator
            )?.passengerTickets
            :
            [...uniqueTickets];
    }, [formValue?.Sectors, sectorWiseTicketIds])

    const allPaxTypeWithTicketIds = useMemo(() => {
        return flightData?.response?.flightItinerary?.passenger?.map((passenger: any) => {
            return { paxType: passenger?.paxType, ticketId: passenger?.ticket?.ticketId }
        })
    }, [flightData?.response?.flightItinerary?.passenger])

    const remainingPaxTypeCounts = useMemo(() => {
        let counts = { adultCounts: passangerPriceBU?.adultCount, childCounts: passangerPriceBU?.childCount, infantCounts: passangerPriceBU?.infantCount };
        if (partialCancelSegment) {
            return formValue?.Sectors?.map((obj: any) => {
                const requestedAdultCounts = partialCancelSegment?.filter((prev: any) => prev?.tripIndicator === obj?.tripIndicator && prev?.paxType === 1)?.length
                const requestedChildCounts = partialCancelSegment?.filter((prev: any) => prev?.tripIndicator === obj?.tripIndicator && prev?.paxType === 2)?.length
                const requestedInfantCounts = partialCancelSegment?.filter((prev: any) => prev?.tripIndicator === obj?.tripIndicator && prev?.paxType === 3)?.length

                obj.adultCounts = passangerPriceBU?.adultCount - requestedAdultCounts;
                obj.childCounts = passangerPriceBU?.childCount - requestedChildCounts;
                obj.infantCounts = passangerPriceBU?.infantCount - requestedInfantCounts;
                return obj;
            })
        }
        else {
            return counts;
        }
    }, [partialCancelSegment, passangerPriceBU, formValue?.Sectors])



    const getcancellationreason = async () => {
        dispatch(loaderActions?.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const reason = await getAllData('/customerui/v1/getreasons')
            if (reason?.status) {
                const updatedReasonList = [{ label: 'Select Reason', value: 0 }, ...createOptionData(reason?.data?.cancellationReasonFlightList)];
                setDropdownData({
                    cancellationReasonFlightList: updatedReasonList
                });
                dispatch(loaderActions?.end());
            }
            else {
                dispatch(loaderActions?.end());
            }
        }
        else {
            dispatch(loaderActions?.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }

    const handleSelect = (name: string, value: any) => {
        setFormError({});
        if (name === "CancellationTypeId") {
            let val = JSON.parse(value)
            if (val?.value !== 1 && val?.value !== 0) {
                setFormValue((prev: any) => ({
                    ...prev,
                    [name]: val?.value,
                    Remarks: val?.label
                }));
            }
            else {
                setFormValue((prev: any) => ({
                    ...prev,
                    [name]: val?.value,
                    Remarks: ''
                }));
            }
        }
        else {
            setFormValue((prev: any) => ({
                ...prev,
                [name]: value
            }));
        }
    }

    const handleDocUpload = (e: any, bookingId: any) => {
        setFormError({});
        const file = e.target.files[0]
        const filecom = getDateCombination();
        let filename = filecom + "_1_" + file?.name;
        setFormValue((prev: any) => ({
            ...prev,
            CancellationImageName: filename,
            CancellationImagePath: `UI/Upcoming/flightbooking//${filename}`,
            Path: `UI/Upcoming/flightbooking//`,
            type: !(file?.type?.includes('image') || file?.type?.includes('pdf')),
            size: ((file?.size / 1024) / 1024) > 20 ? true : false,
            File: file,
            needToUpload: true
        }));
    }


    const handleOnChange = (name: string, value: any) => {
        setFormError({});
        setFormValue((prev: any) => ({
            ...prev,
            [name]: value
        }));
    }


    const validateData = () => {
        let status = true;
        let error: any = {};
        if (formValue?.CancellationTypeId <= 0) {
            error[`CancellationTypeId`] = 'Please select reason.';
            status = false;
        }
        if (formValue?.CancellationImageName?.trim()?.length > 0) {
            if (formValue?.type) {
                error[`CancellationImageName`] = 'Please upload correct image or pdf file.';
                status = false;
            }
            if (formValue?.size) {
                error[`CancellationImageName`] = 'Cannot upload file above 20 MB.';
                status = false;
            }
        }
        if (formValue?.CancellationTypeId === 1 && formValue?.Remarks?.trim()?.length <= 0) {
            error[`Remarks`] = 'Please provide reason.';
            status = false;
        }

        const selectedAdultCount = formValue?.paxTypeWithTicketId?.filter((prev: any) => prev?.paxType === 1)?.length || 0;
        const selectedChildCount = formValue?.paxTypeWithTicketId?.filter((prev: any) => prev?.paxType === 2)?.length || 0;
        const selectedInfantCount = formValue?.paxTypeWithTicketId?.filter((prev: any) => prev?.paxType === 3)?.length || 0;

        if (formValue.CancellationTypeId === 3) {
            if (partialCancelSegment) {
                const adult = formValue?.Sectors?.map((el: any) => el.adultCounts)?.length ? Math.max(...(formValue?.Sectors?.map((el: any) => el.adultCounts))) : 0;
                const child = formValue?.Sectors?.map((el: any) => el.childCounts)?.length ? Math.max(...(formValue?.Sectors?.map((el: any) => el.childCounts))) : 0;
                const infant = formValue?.Sectors?.map((el: any) => el.infantCounts)?.length ? Math.max(...(formValue?.Sectors?.map((el: any) => el.infantCounts))) : 0;

                if (((adult - selectedAdultCount) < 1) && ((child - selectedChildCount) > 0)) {
                    dispatch({ type: 'ALERTING', message: 'Please select the Child and/or Infant passenger(s) for cancellation to continue.' });
                    status = false;
                }
                else if ((adult - selectedAdultCount) < (infant - selectedInfantCount)) {
                    dispatch({ type: 'ALERTING', message: 'Please select the Child and/or Infant passenger(s) for cancellation to continue.' });
                    status = false;
                }
            }
            else {
                const remainAdultCounts = remainingPaxTypeCounts?.adultCounts;
                const remainChildCounts = remainingPaxTypeCounts?.childCounts;
                const remainInfantCounts = remainingPaxTypeCounts?.infantCounts;
                if (((remainAdultCounts - selectedAdultCount) < 1) && ((remainChildCounts - selectedChildCount) > 0)) {
                    dispatch({ type: 'ALERTING', message: 'Please select the Child and/or Infant passenger(s) for cancellation to continue.' });
                    status = false;
                }
                else if ((remainAdultCounts - selectedAdultCount) < (remainInfantCounts - selectedInfantCount)) {
                    dispatch({ type: 'ALERTING', message: 'Please select the Child and/or Infant passenger(s) for cancellation to continue.' });
                    status = false;
                }
                else if (((selectedAdultCount + selectedChildCount + selectedInfantCount) === (remainAdultCounts + remainChildCounts + remainInfantCounts)) && (flightData?.response?.flightItinerary?.segments?.length === formValue?.Sectors?.length)) {
                    dispatch({ type: 'ALERTING', message: 'You have selected all the passengers. Please select Full Cancellation in the options.' });
                    status = false;
                }
            }
        }
        else if (partialCancelSegment?.length > 0) {
            dispatch({ type: 'ALERTING', message: 'Please select Partial cancellation to proceed.' });
            status = false;

        }

        setFormError(error);
        return status;
    }
    const handleApply = async (filghtDetails: any) => {
        if (validateData()) {
            setFormError({});
            const userip = await fetchIp();
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                dispatch(loaderActions?.start());
                const userData: any = GetLocalStorage();
                let obj = {
                    EndUserIp: userip?.data,
                    RequestType: 1,
                    BookingId: filghtDetails?.flightDetails?.response?.flightItinerary?.bookingId,
                    BookingMode: 5,
                    UserId: userData?.userMasterID
                }
                if (formValue.CancellationTypeId === 3) {
                    proceedtoCancel(flightBookingData?.flightDetails?.response?.flightItinerary?.bookingId)
                    setAmount({
                        filghtDetails: filghtDetails,
                        formValue: formValue,
                        isPartial: true,
                    });

                    dispatch(loaderActions.end());
                }
                else {
                    // CancellationTypeId
                    const res = await postUsersData('/customerui/v1/GetCancellationCharges', obj);
                    if (res?.status) {
                        setAmount({
                            ...res?.data,
                            filghtDetails: filghtDetails,
                            formValue: formValue,
                            isPartial: false,
                        });
                        setModalChnage(true)
                        dispatch(loaderActions?.end());
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: res.message });
                        dispatch(loaderActions?.end());
                    }
                }
            }
            else {
                dispatch(loaderActions?.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }
    }

    const proceedtoCancel = async (bookingId: number) => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            dispatch(loaderActions?.start());
            const userip = await fetchIp();
            const item = formValue;
            const userData: any = GetLocalStorage();
            let obj: any = {
                BookingId: bookingId,
                RequestType: 1,     //NotSet = 0,FullCancellation = 1,PartialCancellation = 2,Reissuance = 3
                Remarks: item?.Remarks,
                EndUserIp: userip?.data,
                CancellationTypeId: item?.CancellationTypeId,
                CancellationImageName: item?.CancellationImageName,
                CancellationImagePath: item?.CancellationImagePath,
                UserId: userData?.userMasterID,
                IsAcknowledgement: item?.IsAcknowledgement
            }

            if (formValue.CancellationTypeId === 3) {
                obj = {
                    ...obj,
                    RequestType: 2,
                    Sectors: [...formValue?.Sectors?.map((sector: any) => ({ Origin: sector?.origin, Destination: sector.destination, TripIndicator: sector?.tripIndicator }))],
                    TicketId: formValue?.TicketId,
                }
            }
            const res = await postUsersData('/customerui/v1/SendChangeRequest', obj);
            if (res?.status) {
                if (item?.needToUpload) {
                    try {
                        let isUpload = await ImageUpload(item?.Path, item?.FileName, item?.File);
                        if (isUpload) {
                            dispatch(loaderActions.end());
                        }
                        else {
                            console.error(`Error While Uploading File!`)
                            dispatch(loaderActions.end());
                        }
                    } catch (error) {
                        console.error(`Error While Uploading File: ${error}`)
                        dispatch(loaderActions.end());
                    }
                }
                if (formValue.CancellationTypeId === 3) {
                    setModalChnage(true)
                    setCancellationMessage(res)
                    dispatch(updateActions.updated());
                    dispatch(loaderActions?.end());
                }
                else {
                    setFlightModel(false)
                    navigate('/flights');
                    dispatch(loaderActions?.end());
                }
            }
            else {
                dispatch({ type: 'ALERTING', message: res.message });
                dispatch(loaderActions?.end());
            }
        }
        else {
            dispatch(loaderActions?.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }

    useEffect(() => {
        getcancellationreason();
    }, [])

    const handleCancelCheckBox = (value: any, checked: boolean, name: string) => {
        setFormError({});
        let formValueClone = { ...formValue };

        if (name === 'All') {
            formValueClone = { ...formValueClone, Sectors: checked ? value : [], TicketId: [], paxTypeWithTicketId: [] }
        } else {
            if (checked) {
                formValueClone = { ...formValueClone, Sectors: [...formValueClone?.Sectors, value], TicketId: [], paxTypeWithTicketId: [] }
            }
            else {
                formValueClone = { ...formValueClone, Sectors: [...formValueClone?.Sectors.filter((val: any) => val.origin !== value.origin && val?.destination !== value.destination)], TicketId: [], paxTypeWithTicketId: [] }
            }
        }
        setFormValue(formValueClone);
    }

    const handleCancelCheckBoxPassenger = (value: any, checked: boolean, paxType: any, name: string) => {
        setFormError({});
        let formValueClone = { ...formValue }

        if (name === 'All') {
            formValueClone = { ...formValueClone, TicketId: checked ? value : [], paxTypeWithTicketId: checked ? paxType : [] }
        } else {
            if (checked) {
                formValueClone = {
                    ...formValueClone,
                    TicketId: [...formValueClone.TicketId, value],
                    paxTypeWithTicketId: [...formValueClone?.paxTypeWithTicketId, { paxType: paxType, ticketId: value }]
                }
            } else {
                formValueClone = {
                    ...formValueClone,
                    TicketId: [...formValueClone.TicketId.filter((val: any) => val !== value)],
                    paxTypeWithTicketId: [...formValueClone?.paxTypeWithTicketId?.filter((val: any) => val?.ticketId !== value)],
                }
            }
        }

        setFormValue(formValueClone);
    };


    const groupedFlights = Object.values(
        (flightBookingData?.flightDetails?.response?.flightItinerary?.segments ?? [])?.reduce((acc: any, curr: any) => {
            const key = curr.tripIndicator;
            if (!acc[key]) acc[key] = [];
            acc[key].push(curr);
            return acc;
        }, {})
    );

    useEffect(() => {
        const result = groupedFlights.map((trip: any, index: number) => {
            const firstSegment = trip[0];
            const lastSegment = trip[trip.length - 1];

            return {
                flightRequestSegmentId: 825 + index, // or any logic you need
                origin: firstSegment.origin.airport.cityCode,
                destination: lastSegment.destination.airport.cityCode,
                departureDate: firstSegment.origin.depTime.split("T")[0] + "T00:00:00",
                tripIndicator: trip?.[0]?.tripIndicator
            };
        });

        setSegment(result)
    }, [])

    const getjourneyType = (journeyType: number) => {
        let type = '';
        switch (journeyType) {
            case 1:
                type = 'One-Way';
                break;
            case 2:
                type = 'Return';
                break;
            case 3:
                type = 'Multi Stop';
                break;
            default:
                type = 'One-Way';
                break;
        }
        return type
    }

    const { originCityCode, destinationCityCode } = useMemo(() => {
        if (!amount?.filghtDetails?.flightDetails?.response?.flightItinerary?.segments?.length) return { originCityCode: null, destinationCityCode: null };

        return {
            originCityCode: amount?.filghtDetails?.flightDetails?.response?.flightItinerary?.segments?.map((el: any) => el.origin?.airport?.cityCode),
            destinationCityCode: amount?.filghtDetails?.flightDetails?.response?.flightItinerary?.segments?.map((el: any) => el.destination?.airport?.cityCode),
        };
    }, [amount]);

    return (
        <>
            {!modalchange && <div className="container cancelBooking ">
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                        <div className="form-floating mb-3">
                            <select
                                className="form-select"
                                id={`CancellationTypeId`}
                                name='CancellationTypeId'
                                value={JSON?.stringify(dropdownData?.cancellationReasonFlightList?.find((el: any) => el.value === formValue?.CancellationTypeId)) || ''}
                                onChange={(e) => handleSelect(e.target.name, e?.target?.value)}
                            >
                                {
                                    dropdownData?.cancellationReasonFlightList?.map((list: any) => {
                                        return (
                                            <option key={`${list?.label}${list?.value}`} value={JSON?.stringify(list)}>{list?.label}</option>
                                        );
                                    })
                                }
                            </select>
                            <label htmlFor={`CancellationTypeId`}>Reason</label>
                            {formError[`CancellationTypeId`] && <div className="text-danger f-14"> {formError[`CancellationTypeId`]} </div>}
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                        <div className="mb-3">
                            <input
                                type="file"
                                className="form-control"
                                id="reasonDocument"
                                placeholder="Type a Reason"
                                accept='.pdf,image/*'
                                onChange={(e) => handleDocUpload(e, flightBookingData?.flightDetails?.response?.flightItinerary?.bookingId)}
                            />
                            {formError[`CancellationImageName`] && <div className="text-danger f-14"> {formError[`CancellationImageName`]} </div>}
                        </div>
                    </div>
                    {
                        formValue?.CancellationTypeId === 1 &&
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="form-floating mb-3">
                                <textarea
                                    className="form-control feedback"
                                    placeholder="Type a Reason"
                                    id="Remarks"
                                    name='Remarks'
                                    value={formValue?.Remarks}
                                    onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                                    maxLength={150}
                                />
                                <label htmlFor="Remarks">Type a Reason</label>
                                {formError[`Remarks`] && <div className="text-danger f-14"> {formError[`Remarks`]} </div>}
                            </div>
                        </div>
                    }
                    {formValue?.CancellationTypeId === 3 && (
                        <div className='row mt-3'>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <h4>Please Select Refund Sector</h4>

                                <CheckBoxUi
                                    checked={segment?.length === formValue?.Sectors?.length}
                                    onChange={(e: any) => handleCancelCheckBox(segment, e.target.checked, "All")}
                                    value={`all`}
                                    checkBoxLabel={`All`}
                                    disabled={false}
                                />

                                {segment?.length > 0 && (
                                    segment.map((sectors: any) => (
                                        <CheckBoxUi
                                            checked={formValue?.Sectors?.some((val: any) => val.origin === sectors.origin && val.destination === sectors.destination)}
                                            onChange={(e: any) => handleCancelCheckBox(sectors, e.target.checked, "custom")}
                                            value={`${sectors.origin} - ${sectors.destination}`}
                                            checkBoxLabel={`${sectors?.origin} - ${sectors?.destination} (${formatDateMonthYear(sectors?.departureDate)})`}
                                            disabled={false}
                                        />
                                    ))
                                )}
                                {/* {formError[`Remarks${filghtDetails?.bookingId}`] && <div className="text-danger f-14"> {formError[`Remarks${filghtDetails?.bookingId}`]} </div>} */}
                            </div>

                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <h4>Please Select Passenger</h4>
                                {/* {TicketIds?.length > 1 && (
                )} */}
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="All"
                                        id="allPassenger"
                                        checked={TicketIds?.length > 0 && formValue?.TicketId?.length === TicketIds?.length}
                                        disabled={TicketIds?.length <= 0 ? true : false || formValue?.Sectors?.length <= 0}
                                        onChange={(e) => {
                                            //  const ticketIds = filghtDetails?.tboResponse?.response?.flightItinerary?.passenger.map((passenger) => (passenger?.ticket?.ticketId))
                                            handleCancelCheckBoxPassenger(e.target.checked ? TicketIds : [], e.target.checked, allPaxTypeWithTicketIds, "All")
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="allPassenger">
                                        All
                                    </label>
                                </div>

                                {
                                    flightBookingData?.flightDetails?.response?.flightItinerary?.passenger.map((passenger: any) => (
                                        <CheckBoxUi
                                            checkBoxLabel={passenger?.firstName + " " + passenger?.lastName}
                                            value={passenger?.ticket?.ticketId}
                                            checked={formValue?.TicketId.includes(passenger?.ticket?.ticketId)}
                                            onChange={(e: any) => handleCancelCheckBoxPassenger(Number(e.target.value), e.target.checked, passenger?.paxType, 'costom')}
                                            disabled={formValue?.Sectors?.length <= 0
                                                || ((tripIndicatortraveller?.filter((el: any) => el.ticketId === passenger?.ticket?.ticketId)?.length === formValue?.Sectors?.length) ? tripIndicatortraveller?.filter((el: any) => el.ticketId === passenger?.ticket?.ticketId) : false)}
                                        />
                                    ))
                                }
                                {/* {formError[`Remarks${filghtDetails?.bookingId}`] && <div className="text-danger f-14"> {formError[`Remarks${filghtDetails?.bookingId}`]} </div>} */}
                            </div>


                        </div>
                    )}
                    {
                        formError?.[`AdultPartialCancellation`] &&
                        <div className="text-center text-danger f-14 my-2"> {formError?.[`AdultPartialCancellation`]} </div>
                    }
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                        <button
                            type="button"
                            className="btn sendBtn"
                            onClick={() => handleApply(flightBookingData)}
                            disabled={formValue?.CancellationTypeId <= 0
                                || (formValue?.CancellationTypeId === 1 && formValue?.Remarks?.trim()?.length <= 0)
                                || (formValue?.CancellationTypeId === 3 && (formValue?.Sectors.length <= 0 || formValue?.TicketId.length <= 0))
                            }
                        ><i className="fa-solid fa-paper-plane"></i> Apply</button>
                    </div>
                </div>
            </div>}
            {modalchange &&
                <>
                    {!amount?.isPartial ?
                        <>
                            <div dangerouslySetInnerHTML={{ __html: flightBookingData?.flightDetails?.response?.flightItinerary?.fareRules?.[0]?.fareRuleDetail }}></div>
                            <div className='mt-4'>
                                <table className='w-100 cancelletion_table'>
                                    <tbody>
                                        <tr>
                                            <th>Paid Amount</th>
                                            <td>
                                                <span className='d-flex align-items-center'>
                                                    <img className='me-1' src={RupeeSymbolBlack} style={{ height: '10px' }} alt="logo" />
                                                    {amount?.paidAmount}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Airline Cancellation charge</th>
                                            <td>
                                                <span className='d-flex align-items-center'>
                                                    <img className='me-1' src={RupeeSymbolBlack} style={{ height: '10px' }} alt="logo" />
                                                    {amount?.cancellationCharge}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>ETM Service Fee</th>
                                            <td>
                                                <span className='d-flex align-items-center'>
                                                    <img className='me-1' src={RupeeSymbolBlack} style={{ height: '10px' }} alt="logo" />
                                                    {amount?.etmFee}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Total Refundable Amt</th>
                                            <td>
                                                <span className='d-flex align-items-center'>
                                                    <img className='me-1' src={RupeeSymbolBlack} style={{ height: '10px' }} alt="logo" />
                                                    {amount?.refundAmount}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className=" col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div className='form-check my-3'>
                                        <input className="form-check-input"
                                            type="checkbox"
                                            value={formValue?.IsAcknowledgement}
                                            checked={formValue?.IsAcknowledgement}
                                            onChange={(e) => { setFormValue({ ...formValue, IsAcknowledgement: e.target.checked }) }}
                                            id="allPassenger"
                                        />
                                        <label className="form-check-label" htmlFor="allPassenger">
                                            I Agree to the terms and conditions of the given cancellation policies
                                        </label>
                                    </div>
                                </div>
                                <div className='mt-4 row'>
                                    <div className='col-xl-3 col-md-6 col-12 mb-1 mx-auto'>
                                        <button type="button" className="btn theme-btn me-1 w-100 cancel_remark"
                                            onClick={() => proceedtoCancel(flightBookingData?.flightDetails?.response?.flightItinerary?.bookingId)}
                                            disabled={!formValue?.IsAcknowledgement}
                                        >
                                            Proceed to Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            {cancelletionMessage &&
                                <div className='row'>
                                    <div className='col-lg-5 col-12'>
                                        <div className='ms-2 my-2'>
                                            <div className='mb-1'><span className='fw-bold'>Booking ID&nbsp;:&nbsp;</span>{flightBookingData?.bookingDetails?.[0]?.bookingNo}</div>
                                            <div><span className='fw-bold'>Type&nbsp;:&nbsp;</span>
                                                {getjourneyType(amount?.filghtDetails?.tboResponse?.response?.flightItinerary?.journeyType)}
                                                &nbsp;(
                                                {originCityCode?.map((el: any, index: number) => (
                                                    <span key={index}>
                                                        {el}
                                                        &nbsp;<i className="fa-solid fa-arrow-right-long opacity-75"></i>&nbsp;
                                                    </span>
                                                ))}
                                                &nbsp;{destinationCityCode?.[destinationCityCode?.length - 1]}
                                                )
                                            </div>
                                        </div>
                                        <div className='fightpartial_cancelletion_table ms-1 my-2 overflow-auto'>
                                            <table className='w-100'>
                                                <thead>
                                                    <tr className='mb-2'>
                                                        <th style={{ minWidth: "100px" }}>Passenger</th>
                                                        <th style={{ minWidth: "100px" }}>Sector</th>
                                                        <th style={{ minWidth: "70px" }}>Status</th>
                                                        <th style={{ minWidth: "70px" }}>PNR</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {cancelletionMessage?.data?.passengerList?.map((el: any) => (
                                                        <tr className='mb-2'>
                                                            <td className=''>{el?.PassengerName}</td>
                                                            <td className=''>{el?.Origin}<span>&nbsp;<i className="fa-solid fa-arrow-right-long opacity-75"></i>&nbsp;</span>{el?.Destination}</td>
                                                            <td className=''>{el?.Status}</td>
                                                            <td className=''>{el?.PNR}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className='col-lg-7 col-12'>
                                        <div dangerouslySetInnerHTML={{ __html: amount?.formValue.CancellationTypeId !== 3 ? cancelletionMessage?.data?.message : cancelletionMessage?.data?.message?.[0]?.message }}></div>
                                        <div className='col-xl-12 col-md-6 col-12 mb-1 mx-auto'>
                                            <button
                                                type="button"
                                                className="btn theme-btn me-1 rounded rounded-5 w-100 cancel_remark"
                                                onClick={() => { navigate(RedirectToFllightListScreen()) }}
                                            >Back to Home Page</button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </>
                    }
                </>

            }
        </>
    )
}

export default FlightCancellation